module.exports = __webpack_public_path__ + "static/media/explosion.88bb36ac.gif";